import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Commands } from '@local/client-contracts';
import { PopupService } from '@local/ui-infra';
import { EventsService, LogService, ServicesRpcService } from '@shared/services';
import { DownloadsService } from '@shared/services/downloads.service';
import { FlagsService } from '@shared/services/flags.service';
import { KeyboardService } from '@shared/services/keyboard.service';
import { ResourcesService } from '@shared/services/resources.service';
import { RouterService } from '@shared/services/router.service';
import * as moment from 'moment/moment';
import { IActionItem } from 'src/app/bar/models/action-item.model';
import { CalendarService } from 'src/app/bar/services/calendar.service';
import { HubService } from 'src/app/bar/services/hub.service';
import { HomeResultItemDisplayModel } from '../../../models/home-display-model';
import { CommandBarService } from '../../../services/command-bar.service';
import { CommandsService } from '../../../services/commands/commands.service';
import { CalendarEvent } from '../../results';
import { ResultCommandBuilder } from '../../results/services/result-command-builder.service';
import { HomeResultItemComponent } from '../home-result-item/home-result-item.component';
import { SearchPopUpService } from '../../special-views/search-popup/search-popup.service';

export interface Meeting {
  text: string;
  onClick: Commands.Command;
}
export interface UpNextDisplayModel extends HomeResultItemDisplayModel {
  eventType: string;
  time: string;
  rsvp: string;
}

@Component({
  selector: 'up-next-result-item',
  templateUrl: './up-next-result-item.component.html',
  styleUrls: ['./up-next.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpNextResultItemComponent extends HomeResultItemComponent<CalendarEvent> implements OnInit {
  constructor(
    cdr: ChangeDetectorRef,
    eventsService: EventsService,
    services: ServicesRpcService,
    logService: LogService,
    commandsService: CommandsService,
    commandBarService: CommandBarService,
    popupService: PopupService,
    keyboardService: KeyboardService,
    commandBuilder: ResultCommandBuilder,
    resourcesService: ResourcesService,
    routerService: RouterService,
    hubService: HubService,
    downloadsService: DownloadsService,
    private calendarService: CalendarService,
    flagsService: FlagsService,
    searchPopUpService: SearchPopUpService
  ) {
    super(
      cdr,
      eventsService,
      services,
      logService,
      commandsService,
      commandBarService,
      popupService,
      keyboardService,
      commandBuilder,
      resourcesService,
      routerService,
      hubService,
      downloadsService,
      flagsService,
      searchPopUpService
    );
  }

  get displayModel() {
    return this._displayModel as UpNextDisplayModel;
  }

  set displayModel(value: UpNextDisplayModel) {
    this._displayModel = value;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
  }

  protected async updateDisplayModel(): Promise<void> {
    await super.updateDisplayModel();
    if (!this.displayModel) return;
    this.displayModel.eventType = this.calendarService.getEventType(this.model.start, this.model.end);
    this.calendarService.setTimeFields(moment(this.model.originalStartDate), moment(this.model.originalEndDate), this.displayModel);
    this.displayModel.rsvp = this.getRsvp();
  }

  private getRsvp(): string {
    const rsvpStatus = this.model.rsvp;
    if (rsvpStatus === 'YES') {
      return 'Going';
    } else if (rsvpStatus === 'NO') {
      return 'Not Going';
    } else if (rsvpStatus === 'MAYBE') {
      return 'Maybe Going';
    } else {
      return null;
    }
  }

  // overrides same fn in base class.
  protected getActions(): IActionItem[] {
    return [...this.calendarService.getMeetingsAction(this.model, this.shortcuts), { ...this.allActions.openPreview, hideIcon: true }];
  }
}
